/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { BeamShapingContainerDto } from './BeamShapingContainerDto';
import {
    BeamShapingContainerDtoFromJSON,
    BeamShapingContainerDtoFromJSONTyped,
    BeamShapingContainerDtoToJSON,
} from './BeamShapingContainerDto';
import type { BeamQualityContainerDto } from './BeamQualityContainerDto';
import {
    BeamQualityContainerDtoFromJSON,
    BeamQualityContainerDtoFromJSONTyped,
    BeamQualityContainerDtoToJSON,
} from './BeamQualityContainerDto';
import type { ISingleSystemSetupParameter } from './ISingleSystemSetupParameter';
import {
    ISingleSystemSetupParameterFromJSON,
    ISingleSystemSetupParameterFromJSONTyped,
    ISingleSystemSetupParameterToJSON,
} from './ISingleSystemSetupParameter';

/**
 * 
 * @export
 * @interface MvTherapySystemSetupDto
 */
export interface MvTherapySystemSetupDto {
    /**
     * 
     * @type {string}
     * @memberof MvTherapySystemSetupDto
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof MvTherapySystemSetupDto
     */
    targetSystemEntityId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MvTherapySystemSetupDto
     */
    isSingleSetupParameterListReadOnly?: boolean;
    /**
     * 
     * @type {Array<ISingleSystemSetupParameter>}
     * @memberof MvTherapySystemSetupDto
     */
    singleSetupParameters: Array<ISingleSystemSetupParameter>;
    /**
     * 
     * @type {BeamQualityContainerDto}
     * @memberof MvTherapySystemSetupDto
     */
    beamQualityContainer: BeamQualityContainerDto;
    /**
     * 
     * @type {BeamShapingContainerDto}
     * @memberof MvTherapySystemSetupDto
     */
    beamShapingContainer: BeamShapingContainerDto;
    /**
     * 
     * @type {string}
     * @memberof MvTherapySystemSetupDto
     */
    $type?: MvTherapySystemSetupDtoTypeEnum;
}


/**
 * @export
 */
export const MvTherapySystemSetupDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoMvTherapySystemSetupDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.MvTherapySystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type MvTherapySystemSetupDtoTypeEnum = typeof MvTherapySystemSetupDtoTypeEnum[keyof typeof MvTherapySystemSetupDtoTypeEnum];



/**
 * Check if a given object implements the MvTherapySystemSetupDto interface.
 */
export function instanceOfMvTherapySystemSetupDto(value?: unknown): value is MvTherapySystemSetupDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(MvTherapySystemSetupDtoTypeEnum)[0];
}

export function MvTherapySystemSetupDtoFromJSON(json: any): MvTherapySystemSetupDto {
    return MvTherapySystemSetupDtoFromJSONTyped(json, false);
}

export function MvTherapySystemSetupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MvTherapySystemSetupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'targetSystemEntityId': json['targetSystemEntityId'] == null ? undefined : json['targetSystemEntityId'],
        'isSingleSetupParameterListReadOnly': json['isSingleSetupParameterListReadOnly'] == null ? undefined : json['isSingleSetupParameterListReadOnly'],
        'singleSetupParameters': ((json['singleSetupParameters'] as Array<any>).map(ISingleSystemSetupParameterFromJSON)),
        'beamQualityContainer': BeamQualityContainerDtoFromJSON(json['beamQualityContainer']),
        'beamShapingContainer': BeamShapingContainerDtoFromJSON(json['beamShapingContainer']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function MvTherapySystemSetupDtoToJSON(value?: MvTherapySystemSetupDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'groupId': value['groupId'],
        'targetSystemEntityId': value['targetSystemEntityId'],
        'isSingleSetupParameterListReadOnly': value['isSingleSetupParameterListReadOnly'],
        'singleSetupParameters': ((value['singleSetupParameters'] as Array<any>).map(ISingleSystemSetupParameterToJSON)),
        'beamQualityContainer': BeamQualityContainerDtoToJSON(value['beamQualityContainer']),
        'beamShapingContainer': BeamShapingContainerDtoToJSON(value['beamShapingContainer']),
        '$type': value['$type'],
    });
}

